
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/hwajangjang-yeyak",
      function () {
        return require("private-next-pages/guide/hwajangjang-yeyak.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/hwajangjang-yeyak"])
      });
    }
  